/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Comparison_SellerInputs */

const id_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penjual`)
};

const ms_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penjual`)
};

const da_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sælger`)
};

const de_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkäufer`)
};

const en_us2_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller`)
};

const es_es2_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor`)
};

const es_mx2_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor`)
};

const fil_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagbebenta`)
};

const fr_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendeur`)
};

const it_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venditore`)
};

const hu_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eladó`)
};

const nl_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkoper`)
};

const no_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selger`)
};

const pl_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprzedawca`)
};

const pt_br2_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller`)
};

const pt_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor`)
};

const ro_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vânzător`)
};

const fi_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Myyjä`)
};

const sv_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Säljare`)
};

const vi_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người bán`)
};

const tr_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satıcı`)
};

const cs_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prodejce`)
};

const bg_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавач`)
};

const ru_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавец`)
};

const uk_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавець`)
};

const ar_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البائع`)
};

const hi_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विक्रेता`)
};

const th_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้ขาย`)
};

const ja_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`販売元`)
};

const zh_cn2_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller`)
};

const zh_hant1_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller`)
};

const ko_components_comparison_seller = /** @type {(inputs: Components_Comparison_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller`)
};

/**
* | output |
* | --- |
* | "Seller" |
*
* @param {Components_Comparison_SellerInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_comparison_seller = /** @type {((inputs?: Components_Comparison_SellerInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Comparison_SellerInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_comparison_seller(inputs)
	if (locale === "ms") return ms_components_comparison_seller(inputs)
	if (locale === "da") return da_components_comparison_seller(inputs)
	if (locale === "de") return de_components_comparison_seller(inputs)
	if (locale === "en-US") return en_us2_components_comparison_seller(inputs)
	if (locale === "es-ES") return es_es2_components_comparison_seller(inputs)
	if (locale === "es-MX") return es_mx2_components_comparison_seller(inputs)
	if (locale === "fil") return fil_components_comparison_seller(inputs)
	if (locale === "fr") return fr_components_comparison_seller(inputs)
	if (locale === "it") return it_components_comparison_seller(inputs)
	if (locale === "hu") return hu_components_comparison_seller(inputs)
	if (locale === "nl") return nl_components_comparison_seller(inputs)
	if (locale === "no") return no_components_comparison_seller(inputs)
	if (locale === "pl") return pl_components_comparison_seller(inputs)
	if (locale === "pt-BR") return pt_br2_components_comparison_seller(inputs)
	if (locale === "pt") return pt_components_comparison_seller(inputs)
	if (locale === "ro") return ro_components_comparison_seller(inputs)
	if (locale === "fi") return fi_components_comparison_seller(inputs)
	if (locale === "sv") return sv_components_comparison_seller(inputs)
	if (locale === "vi") return vi_components_comparison_seller(inputs)
	if (locale === "tr") return tr_components_comparison_seller(inputs)
	if (locale === "cs") return cs_components_comparison_seller(inputs)
	if (locale === "bg") return bg_components_comparison_seller(inputs)
	if (locale === "ru") return ru_components_comparison_seller(inputs)
	if (locale === "uk") return uk_components_comparison_seller(inputs)
	if (locale === "ar") return ar_components_comparison_seller(inputs)
	if (locale === "hi") return hi_components_comparison_seller(inputs)
	if (locale === "th") return th_components_comparison_seller(inputs)
	if (locale === "ja") return ja_components_comparison_seller(inputs)
	if (locale === "zh-CN") return zh_cn2_components_comparison_seller(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_comparison_seller(inputs)
	return ko_components_comparison_seller(inputs)
});
export { components_comparison_seller as "components.comparison.seller" }